import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Page, PageLoader, TabLayout } from 'modules/ui';
import { showNotification, Notification } from 'modules/notifications';
import { getAgent, updateAgent } from '../redux';
import { AgentProfileTabs, SocialLinksForm } from '../components';

export default function EditSocialPage() {
  const dispatch = useDispatch();
  const agent = useSelector(getAgent);

  function handleSubmitSocialLinks(values) {
    return dispatch(
      updateAgent(agent.account.id, agent.id, values),
    ).then(() =>
      dispatch(
        showNotification({
          message: 'Social media links successfully saved',
          type: Notification.TYPES.SUCCESS,
        }),
      ),
    );
  }

  if (!agent) {
    return <PageLoader />;
  }

  return (
    <Page>
      <TabLayout tabs={<AgentProfileTabs />}>
        <SocialLinksForm
          initialValues={agent}
          onSubmit={handleSubmitSocialLinks}
        />
      </TabLayout>
    </Page>
  );
}
